import initAxe from "./axe";
import { polyfillLocalStorage } from "./localStoragePolyfill";

export interface InitParams {
  reactVersion: unknown;
  reactDomVersion: unknown;
}

export default (initParams: InitParams): void => {
  initAxe(initParams.reactVersion, initParams.reactDomVersion);
  polyfillLocalStorage();
};
